import {
  Autocomplete,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery
} from '@mui/material';
import theme from '../theme.js';
import SearchIcon from '@mui/icons-material/Search';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import React, { useState } from 'react';

export const CmpButton = ({
  xbtnName = '',
  xOnClick,
  xVariant = 'contained',
  xDisabled = false,
  xSize = 'small',
  xId = '',
  xStartIcon = '',
  xendIcon = ''
}) => {
  const fTextFieldDummy = (e) => {};
  return (
    <Button
      id={xId}
      onClick={xOnClick ? xOnClick : fTextFieldDummy}
      variant={xVariant}
      disabled={xDisabled}
      size={xSize}
      className="btn-text-transform-none btn-min-width btn-nav-font"
      sx={{
        width: 'auto',
        borderRadius: '20px',
        justifyContent: 'center',
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.text,
        textTransform: 'capitalize'
      }}
      startIcon={xStartIcon}
      endIcon={xendIcon}>
      {xbtnName}
    </Button>
  );
};

export const CmpButtonNew = ({
  xbtnName = '',
  xOnClick,
  xVariant = '',
  xDisabled = false,
  xId = '',
  xStartIcon = '',
  xendIcon = '',
  xColor = '',
  xMediaQuery
}) => {
  const fTextFieldDummy = (e) => {};
  const vMediaQuery = useMediaQuery('(max-width:600px)');
  return (
    <Button
      id={xId}
      onClick={xOnClick ? xOnClick : fTextFieldDummy}
      variant={xVariant}
      disabled={xDisabled}
      color={xColor}
      className="btn-text-transform-none btn-min-width btn-nav-font"
      sx={{
        width: vMediaQuery ? '100% ' : '25%',
        padding: '0px',
        height: '40px',
        textTransform: 'capitalize',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: vMediaQuery ? '0px' : '2px',
        '& .MuiButton-startIcon': {
          marginRight: vMediaQuery ? '3px !important' : '5px'
        }
      }}
      startIcon={xStartIcon}
      endIcon={xendIcon}>
      <span style={{ marginTop: '2px' }}> {xbtnName}</span>
    </Button>
  );
};

export const CmpButtonError = ({
  xbtnName = '',
  xOnClick,
  xVariant = 'contained',
  xDisabled = false,
  xSize = 'small',
  xId = '',
  xSendIcon = '',
  xendIcon = ''
}) => {
  const fTextFieldDummy = (e) => {};
  return (
    <Button
      id={xId}
      onClick={xOnClick ? xOnClick : fTextFieldDummy}
      variant={xVariant}
      disabled={xDisabled}
      size={xSize}
      className="btn-text-transform-none btn-min-width btn-nav-font"
      sx={{
        width: 'auto',
        borderRadius: '20px',
        justifyContent: 'center',
        backgroundColor: theme.palette.statusClr.red,
        color: theme.palette.primary.text,
        textTransform: 'capitalize',
        '&:hover': {
          backgroundColor: theme.palette.statusClr.red,
          color: theme.palette.primary.text
        }
      }}
      startIcon={xSendIcon}
      endIcon={xendIcon}>
      {xbtnName}
    </Button>
  );
};

export const CmpStyleButton = ({
  xbtnName = '',
  xOnClick,
  xVariant = 'outlined',
  xDisabled = false,
  xSize = 'small',
  xId = '',
  xSendIcon = '',
  xendIcon = ''
}) => {
  const vMediaQuery = useMediaQuery('(max-width:450px)');
  const fTextFieldDummy = (e) => {};
  return (
    <Button
      id={xId}
      onClick={xOnClick ? xOnClick : fTextFieldDummy}
      variant={xVariant}
      disabled={xDisabled}
      size={xSize}
      sx={{
        textTransform: 'capitalize',
        fontSize: vMediaQuery ? '12px' : '14px',
        width: { xs: '100%', sm: '90%', md: '90%' }
      }}
      startIcon={xSendIcon}
      endIcon={xendIcon}>
      {xbtnName}
    </Button>
  );
};

export const ComButton = ({
  xbtnName = '',
  xOnClick,
  xVariant = 'contained',
  xDisabled = false,
  xSize = 'small',
  xId = '',
  xSendIcon = '',
  xendIcon = ''
}) => {
  const vMediaQuery = useMediaQuery('(max-width:450px)');
  const fTextFieldDummy = (e) => {};
  return (
    <Button
      id={xId}
      onClick={xOnClick ? xOnClick : fTextFieldDummy}
      variant={xVariant}
      disabled={xDisabled}
      size={xSize}
      sx={{
        textTransform: 'capitalize',
        fontSize: vMediaQuery ? '12px' : '14px'
        //width:'40%'
      }}
      startIcon={xSendIcon}
      endIcon={xendIcon}>
      {xbtnName}
    </Button>
  );
};

export const CmpTypographyHead = ({ xcomponent, xText, xVariant = 'h6' }) => {
  const xMediaQuery = useMediaQuery('(max-width:450px)');
  return (
    <div className="txt-overflow-ellipse">
      <Typography
        variant={xVariant}
        component={xcomponent}
        sx={{
          fontSize: xMediaQuery ? '14.6px' : '20px',
          textDecoration: 'underline',
          fontWeight: xMediaQuery ? 600 : ''
        }}>
        {xText}
      </Typography>
    </div>
  );
};

export const CmpTypographyHeader = ({ xText }) => {
  const xMediaQuery = useMediaQuery('(max-width:450px)');
  return (
    <div className="txt-overflow-ellipse">
      <Typography
        variant={xMediaQuery ? 'subtitle1' : 'h6'}
        sx={{
          mb: xMediaQuery ? 1 : 0,
          color: theme.palette.primary.main,
          fontWeight: 'bold'
        }}>
        {xText}
      </Typography>
    </div>
  );
};

export const CmpTypography = ({ xcomponent, xText, xVariant = 'body1' }) => {
  const vMediaQuery = useMediaQuery('(max-width:450px)');
  return (
    <div className="txt-overflow-ellipse">
      <Typography
        variant={xVariant}
        component={xcomponent}
        sx={{
          fontSize: vMediaQuery ? '12px' : '14px',
          marginBottom: '4px',
          fontFamily: theme.palette.primary.font
        }}>
        {xText}
      </Typography>
    </div>
  );
};
export const ContactTypography = ({ xcomponent, xText, xVariant = 'body1' }) => {
  const vMediaQuery = useMediaQuery('(max-width:450px)');
  return (
    <div className="txt-overflow-ellipse">
      <Typography
        variant={xVariant}
        component={xcomponent}
        sx={{
          fontSize: vMediaQuery ? '12px' : '14px',
          marginTop: '6px',
          fontFamily: theme.palette.primary.font
        }}>
        {xText}
      </Typography>
    </div>
  );
};
export const CmpTypographyCom = ({ xcomponent, xText, className, xVariant = 'body1', style }) => {
  const vMediaQuery = useMediaQuery('(max-width:450px)');
  return (
    <div className="txt-overflow-ellipse">
      <Typography
        variant={xVariant}
        className={className}
        component={xcomponent}
        style={style}
        sx={{
          fontSize: vMediaQuery ? '12px' : '14px',
          marginTop: '4px',
          fontFamily: theme.palette.primary.font
        }}>
        {xText}
      </Typography>
    </div>
  );
};

export const SoftwareTypography = ({ xcomponent, xText, xVariant = 'body1', xStyle }) => {
  const vMediaQuery = useMediaQuery('(max-width:450px)');
  return (
    <div className="txt-overflow-ellipse">
      <Typography
        variant={xVariant}
        component={xcomponent}
        sx={{ fontSize: vMediaQuery ? '12px' : '13px', fontFamily: theme.palette.primary.font }}
        style={xStyle}>
        {xText}
      </Typography>
    </div>
  );
};

export const CmpTypographyStandard = ({ xcomponent, xText, xVariant = 'body1' }) => {
  const vMediaQuery = useMediaQuery('(max-width:450px)');
  return (
    <div className="txt-overflow-ellipse">
      <Typography
        variant={xVariant}
        component={xcomponent}
        sx={{ fontSize: vMediaQuery ? '12px' : '14px', fontFamily: theme.palette.primary.font }}>
        {xText}
      </Typography>
    </div>
  );
};
export const CmpTypographyTrans = ({ xcomponent, xText, xVariant = 'body1' }) => {
  const vMediaQuery = useMediaQuery('(max-width:450px)');
  return (
    <div className="txt-overflow-ellipse">
      <Typography
        variant={xVariant}
        component={xcomponent}
        sx={{
          fontSize: vMediaQuery ? '10px' : '12px',
          fontFamily: theme.palette.primary.font,
          color: theme.palette.primary.main
        }}>
        {xText}
      </Typography>
    </div>
  );
};

export const SearchInput = ({
  xId,
  id,
  xOptions,
  xName,
  getOptionLabel,
  value,
  xType,
  xLabel,
  xOnChange,
  xDefaultValue,
  xOnInputChange,
  xOnBlur,
  xError,
  xDisabled,
  xHelperText,
  xOnKeyDown,
  xOnKeyUp,
  xRequired,
  xEndAdornment
}) => {
  return (
    <div className="txt-overflow-ellipse">
      <Autocomplete
        freeSolo
        id={id}
        disableClearable
        type={xType}
        defaultValue={xDefaultValue}
        options={xOptions}
        getOptionLabel={getOptionLabel}
        value={value}
        onChange={xOnChange}
        onInputChange={xOnInputChange}
        disabled={xDisabled}
        onBlur={xOnBlur}
        onKeyDown={xOnKeyDown}
        onKeyUp={xOnKeyUp}
        renderInput={(params) => (
          <TextField
            {...params}
            id={xId}
            label={xLabel}
            name={xName}
            error={xError}
            helperText={xHelperText}
            variant="outlined"
            required={xRequired}
            InputProps={{
              ...params.InputProps,
              type: 'search',
              endAdornment: xEndAdornment
            }}
          />
        )}
      />
    </div>
  );
};

export const AnimatedSearchField = ({
  value,
  onChange,
  placeholder = 'Search...',
  onSearchClick = () => {},
  sx = {},
  ...props
}) => {
  const [sFocused, setSfocused] = useState(false);

  return (
    <TextField
      id="filter"
      variant="outlined"
      margin="normal"
      autoComplete="off"
      placeholder={sFocused ? placeholder : ''}
      value={value}
      onFocus={() => setSfocused(true)}
      onBlur={() => {
        if (!value) setSfocused(false);
      }}
      onChange={onChange}
      sx={{
        '& .MuiInputBase-input': {
          padding: '10px 14px !important'
        },
        '& .MuiFormLabel-root': {
          top: '-7px !important'
        },
        '& .MuiInputBase-root': {
          paddingRight: '0px !important',
          borderRadius: '20px !important',
          transition: 'all 0.4s ease',
          width: sFocused ? '100%' : '70px'
        },
        '& .MuiOutlinedInput-notchedOutline': {
          border: sFocused ? '1px solid rgba(0, 0, 0, 0.23)' : 'none'
        },
        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
          border: sFocused ? '1px solid rgba(0, 0, 0, 0.23)' : 'none'
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
          border: sFocused ? '1px solid #1976d2' : 'none'
        },
        ...sx
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={() => {
                setSfocused(true);
                onSearchClick();
              }}
              sx={{
                border: sFocused ? 'none' : '1px solid #dbd1d1',
                padding: '6px !important',
                backgroundColor: sFocused ? 'transparent' : 'white'
              }}>
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        )
      }}
      {...props}
    />
  );
};

export const NumberInputFieldV1 = ({
  label,
  name,
  id,
  value,
  onChange,
  onFocus,
  onBlur,
  onEnterFocusId,
  fullWidth = true,
  onKeyUp,
  style,
  headline,
  error,
  helperText,
  allowDecimal = true,
  ...props
}) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && onEnterFocusId) {
      e.preventDefault();
      document.getElementById(onEnterFocusId)?.focus();
    }
  };

  const handleChange = (e) => {
    const value = e.target.value;

    const pattern = allowDecimal ? /^\d*\.?\d*$/ : /^\d*$/;

    if (pattern.test(value)) {
      onChange?.(e); // Pass to parent
    }
  };

  return (
    <TextField
      fullWidth={fullWidth}
      label={label}
      name={name}
      id={id}
      type="text"
      value={value}
      onChange={handleChange}
      onFocus={onFocus}
      onBlur={onBlur}
      onKeyDown={handleKeyDown}
      onKeyUp={onKeyUp}
      error={error}
      helperText={helperText}
      autoComplete="off"
      {...props}
      sx={{
        '& .MuiOutlinedInput-input': {
          textAlign:
            headline === 'tblPriceGrp'
              ? 'center !important'
              : headline === 'tblAmount'
              ? 'right  !important'
              : 'left !important'
        }
      }}
    />
  );
};

export const ReadOnlyDisplayField = ({
  value,
  label = '',
  variant = 'standard',
  fullWidth = true,
  ...props
}) => {
  return (
    <TextField
      fullWidth={fullWidth}
      variant={variant}
      value={value || ''}
      label={label}
      InputProps={{ readOnly: true }}
      {...props}
    />
  );
};

export const CustomCheckboxField = ({
  label,
  name,
  checked,
  onChange,
  onKeyUp,
  heading,
  onKeyDown,
  sx = {},
  ...props
}) => {
  return (
    <FormControlLabel
      className="checkbox-style"
      sx={{
        '.MuiCheckbox-root': {
          padding: heading === 'TaskDetail' ? '0px 9px !important' : ''
        },
        ...sx
      }}
      control={
        <Checkbox
          name={name}
          checked={checked}
          onChange={onChange}
          onKeyUp={onKeyUp}
          onKeyDown={onKeyDown}
          {...props}
        />
      }
      label={label}
    />
  );
};

export const CopyIcon = ({ text, rowId, copiedDetails, handleCopy }) => {
  // Logic to check if the current row was copied
  const isCopied = copiedDetails.id === rowId && copiedDetails.text === text;

  return (
    <ContentCopyIcon
      sx={{
        fontSize: '14px',
        cursor: 'pointer',
        color: isCopied ? 'green' : theme.palette.primary.main,
        marginLeft: '5px !important'
      }}
      onClick={() => handleCopy(text, rowId)}
    />
  );
};

export const EllipsisTooltip = ({ text }) => {
  return (
    <Tooltip title={text} arrow>
      <div
        style={{
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          width: '100%',
          fontSize: 'inherit' // match surrounding font
        }}>
        {text}
      </div>
    </Tooltip>
  );
};

const statusColors = {
  ENTER: theme.palette.statusClr.open,
  POST: theme.palette.statusClr.verified,
  REJECT: theme.palette.statusClr.reject,
  DEFAULT: 'gray'
};

export const StatusCell = ({ value }) => {
  const color = statusColors[value?.toUpperCase()] || statusColors.DEFAULT;

  return (
    <div
      style={{
        color: 'white',
        backgroundColor: color,
        padding: '4px 8px',
        borderRadius: '4px',
        textAlign: 'center',
        width: '100%',
        fontWeight: 'bold'
      }}>
      {value}
    </div>
  );
};

export const StatusCellV2 = ({ value }) => {
  const color = statusColors[value?.toUpperCase()] || statusColors.DEFAULT;

  return (
    <div
      style={{
        color: 'white',
        backgroundColor: color,
        padding: '2px 8px',
        borderRadius: '4px',
        textAlign: 'center',
        width: '100%',
        fontWeight: 'bold'
      }}>
      {value}
    </div>
  );
};

export const StatusCellV1 = ({ value }) => {
  const color = statusColors[value?.toUpperCase()] || statusColors.DEFAULT;

  return (
    <div
      style={{
        color: 'white',
        backgroundColor: color,
        padding: '6px 8px',
        borderRadius: '4px',
        textAlign: 'center',
        width: '100%',
        fontWeight: 'bold'
      }}>
      {value}
    </div>
  );
};

export const StatusCellV3 = ({ value }) => {
  let color;
  switch (value) {
    case 'Progress':
    case 'In-Progress':
    case 'Pending':
      color = theme.palette.statusClr.progress;
      break;
    case 'Done':
      color = theme.palette.statusClr.verified;
      break;
    case 'Completed':
    case 'Successfull':
      color = theme.palette.statusClr.completed;
      break;
    case 'Deleted':
    case 'Un-Successfull':
      color = theme.palette.statusClr.reject;
      break;
    default:
      color = 'gray';
  }

  return (
    <div
      style={{
        color: 'white',
        backgroundColor: color,
        padding: '2px 2px',
        borderRadius: '4px',
        textAlign: 'center',
        width: '100%',
        fontWeight: 'bold'
      }}>
      {value}
    </div>
  );
};

export const ChipLevel = ({ value, color }) => {
  return (
    <div
      style={{
        color: 'white',
        backgroundColor: color,
        padding: '4px 8px',
        borderRadius: '4px',
        width: '100%'
      }}>
      {value}
    </div>
  );
};
